var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "slsy-loader" }, [
    _c("div", { staticClass: "slsy-loader__circle", style: _vm.styleObject }, [
      _c("svg", { attrs: { viewBox: "22 22 44 44" } }, [
        _c("circle", {
          attrs: {
            cx: "44",
            cy: "44",
            r: "20.2",
            fill: "none",
            "stroke-width": "3.6"
          }
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }